import React, { FC } from "react";
import { Outlet } from "react-router-dom";

const AuthPageContainer: FC = () => {
  return (
    <div className="row m-0 p-0 h-100">
      <Outlet />
      {/* The chat on the sign-in pages (/auth/*) only. */}
    </div>
  );
};

export default AuthPageContainer;
